<style></style>

<template>
    <div class="alert alert-info p-0 mt-4" style="border-radius: 10px;">
        
        <h4 class="bg-primary text-white p-3" style="border-radius: 10px 10px 0 0;" v-if="isProgramUser">Set Completion Date</h4>
        <h4 class="bg-primary text-white p-3" style="border-radius: 10px 10px 0 0;" v-if="!isProgramUser">Goal Completion Date</h4>

        <div class="d-flex justify-content-between p-3">
            <div>
                <small>
                    <div v-if="(!isComplete && edit) || !isProgramUser">
                        <strong>Today's Date:</strong>
                        {{today.format('MM/DD/YYYY')}}
                    </div>
                    <div v-if="isStarted">
                        <strong>We started this action plan:</strong>
                        {{ startedDate }}
                    </div>

                    <div v-if="isComplete">
                        <strong>Our target completion date was:</strong>
                        {{ targetDate }}
                        <br>
                        <strong>We reached our goal on:</strong>
                        {{ completedDate }}
                    </div>

                    <div class="form-inline" v-else>
                        <label for="target-date-input">
                            <strong>We will reach our goal on:</strong>
                        </label>
                        
                        <bootstrap-date-picker 
                            v-show="edit" 
                            :value="targetDate" 
                            v-on:input="setDays($event)" 
                            id="target-date-input" 
                            class="form-control" 
                        />
                        
                        <span v-show="!edit">{{ targetDate }}</span>
                    </div>
                </small>
            </div>
            <div style="width: 40%" class="border-left pl-4" v-if="isProgramUser">
                <small>When choosing a date, think about holidays, breaks and when you plan to reach other goals.</small>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import BootstrapDatePicker from '../BootstrapDatePicker'
    import Auth from '../../auth'

    export default {
        components: {
            BootstrapDatePicker
        },
        props: {
            actionPlan: {
                required: true,
                type: Object
            },
            edit: {
                required: true,
                type: Boolean
            }
        },
        data() {
            return {
                apCopy: {
                    steps: []
                }
            }
        },
        computed: {
            today: function () {
                return moment()
            },
            startedDate: function () {
                if (this.isStarted) {
                    return moment(this.apCopy.date_started).format('MM/DD/YYYY')
                }
                return null;
            },
            targetDate: function () {
                if(this.startedDate) {
                    return moment(this.startedDate)?.add(this.apCopy.days_to_complete, 'days')?.format('MM/DD/YYYY')
                }
                return null;
            },
            completedDate: function () {
                if (this.apCopy.date_completed) {
                    return moment(this.apCopy.date_completed).format('MM/DD/YYYY')
                }
                return null
            },
            isStarted: function () {
                return (this.apCopy.date_started !== null)
            },
            isComplete: function () {
                return (this.apCopy.date_completed !== null)
            },
            isProgramUser(){
                return Auth.is('program-user')
            }
        },
        watch: {
            actionPlan: function() {
                this.syncActionPlan()
            }
        },
        methods: {
            setDays(date) {
                let daysToComplete;

                if(this.startedDate) {
                    daysToComplete = moment(date).diff(this.startedDate, 'days');
                } else {
                    daysToComplete = moment(date).diff(this.today, 'days');
                }
                this.apCopy.days_to_complete = daysToComplete;
                
                axios.put('/api/action-plans/'+this.apCopy.id, {days_to_complete: this.apCopy.days_to_complete})
                    .catch((error) => {
                        console.error(error);
                        alert('there was a problem updating the date')
                    });
            },
            syncActionPlan() {
                this.apCopy = JSON.parse(JSON.stringify(this.actionPlan))                
            }
        }, 
        mounted() {
            this.syncActionPlan()
        }   
}
</script>